import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="logo-icon">📝</span>
              <span className="logo-text">PrivateSold</span>
            </Link>
            <p className="footer-tagline">
              Generate professional bills of sale and invoices for your online transactions.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Documents</h4>
              <Link to="/bill-of-sale">Bill of Sale</Link>
              <Link to="/invoice">Invoice</Link>
            </div>
            <div className="footer-column">
              <h4>Resources</h4>
              <Link to="/blog">Blog</Link>
              <Link to="/subscription">Pricing</Link>
            </div>
            <div className="footer-column">
              <h4>Account</h4>
              <Link to="/login">Login</Link>
              <Link to="/register">Sign Up</Link>
            </div>
            <div className="footer-column">
              <h4>Legal</h4>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} PrivateSold. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
